module.exports = __webpack_public_path__ + "static/media/oksjonid.59c608a1.svg";